/**
 * Functional LAB — central site configuration.
 * All public-page contact details, socials, hours and messaging live here.
 * Do NOT hard-code these values in individual components — read from this module
 * so future changes are one-file changes.
 */

export const SITE = {
  brand: "Functional LAB",
  tagline: "Movement is Medicine.",

  // Hero background video — swap with your own MP4 URL when you have footage.
  // Uses a free Pexels stock athlete-sprint clip as the temporary source.
  // Any direct .mp4 or .webm URL works. Keep videos silent, 10–30 s, 1080p.
  heroVideo: {
    hd:     "https://videos.pexels.com/video-files/5319334/5319334-hd_1920_1080_25fps.mp4",
    sd:     "https://videos.pexels.com/video-files/6002071/6002071-hd_1920_1080_30fps.mp4",
    // Poster image shown before the video loads (also used as accessible fallback for slow connections)
    poster: "https://images.unsplash.com/photo-1696536823512-79d724454616?crop=entropy&cs=srgb&fm=jpg&q=85",
  },

  // Contact
  phone: "+44 7435 053923",
  phoneRaw: "447435053923",        // for tel:/wa.me links (no plus, no spaces)
  email: "functional.lab25@gmail.com",

  // Physical location — CONFIRM BEFORE PUBLISH
  address: {
    // Placeholder — replace with the confirmed clinic address before publish.
    line1: "Address to be confirmed",
    line2: "",
    city: "London",
    postcode: "",
    country: "United Kingdom",
    // Google Maps URL for embed / directions. Placeholder — replace once address is finalised.
    mapsQuery: "Functional+LAB+London",
  },

  // Opening hours — CONFIRM BEFORE PUBLISH
  hours: [
    { day: "Mon–Fri", hours: "By appointment" },
    { day: "Saturday", hours: "By appointment" },
    { day: "Sunday", hours: "Closed" },
  ],
  hoursNote: "Available for in-person, remote and hybrid appointments — please confirm times when booking.",

  // Social — only include profiles that exist. Set to null to hide the icon everywhere.
  socials: {
    instagram: {
      handle: "@functional_lab_",
      url: "https://www.instagram.com/functional_lab_/",
    },
    facebook: null, // Set to { handle, url } once the Facebook page URL is provided.
  },
};

/** Build a wa.me deep link with a URL-encoded pre-filled message. */
export function whatsappUrl(message) {
  const msg = message || DEFAULT_WA_MESSAGES.general;
  return `https://wa.me/${SITE.phoneRaw}?text=${encodeURIComponent(msg)}`;
}

/** Contextual pre-filled messages — one per surface. */
export const DEFAULT_WA_MESSAGES = {
  general: "Hi Functional LAB, I have visited your website and I would like some information about your services.",
  hero: "Hi Functional LAB, I would like to know more about how you could help me.",
  services: "Hi Functional LAB, I would like some information about the services you offer.",
  memberships: "Hi Functional LAB, could you tell me more about your memberships and packages?",
  remote: "Hi Functional LAB, I am interested in your remote rehabilitation options — could you help?",
  team: "Hi Functional LAB, I would like to speak with someone from your team.",
  contact: "Hi Functional LAB, I would like to get in touch about an assessment or appointment.",
  bookAssessment: "Hi Functional LAB, I would like to book an assessment. Please could you let me know your availability?",
  injury: "Hi Functional LAB, I have an injury and I would like some guidance.",
  finder: "Hi Functional LAB, I am not sure which of your services would suit me best — could you help me choose?",
  rehab: "Hi Functional LAB, I would like to begin a rehabilitation programme.",
  resources: "Hi Functional LAB, I have a question after reading one of your resources — could you help?",
};

/** Contextual button labels — matches the brief. */
export const WA_LABELS = {
  general: "Chat with us on WhatsApp",
  contact: "Contact Us on WhatsApp",
  question: "Ask Us a Question",
  book: "Book Your Assessment",
  injury: "Discuss Your Injury",
  finder: "Find the Right Service",
  team: "Speak to the Functional LAB Team",
  rehab: "Start Your Rehabilitation",
  memberships: "Chat About Memberships",
  message: "Message Us on WhatsApp",
};
